import { CareerSiteFiltersOption } from 'api-clients/monolith';
import React from 'react';
import { useIntl } from 'react-intl';

import { SearchSelect } from '../v2/search-select/index';

interface RadiusSelectProps {
  localRadius: CareerSiteFiltersOption | null;
  radiusOptions: CareerSiteFiltersOption[];
  locationSearch: string;
  onRadiusChange: (value: string) => void;
  isRemoteLocation?: boolean;
}

export function RadiusSelect({
  localRadius,
  radiusOptions,
  locationSearch,
  onRadiusChange,
  isRemoteLocation = false,
}: RadiusSelectProps) {
  const intl = useIntl();
  const isDisabled = !locationSearch || isRemoteLocation;

  return (
    <div className="w-[126px] shrink-0">
      <SearchSelect
        value={isDisabled ? undefined : localRadius?.key}
        options={radiusOptions}
        disabled={isDisabled}
        onChange={onRadiusChange}
        placeholder={
          isDisabled
            ? intl.formatMessage({
                defaultMessage: 'Any',
                description:
                  'Placeholder shown for radius when searching all locations',
              })
            : intl.formatMessage({
                defaultMessage: 'Select distance',
                description: 'Placeholder for distance select',
              })
        }
        variant="input"
        noBorder
      />
    </div>
  );
}
